import { FleetMode } from "@/enum/FleetMode"
import { getDefaultFleetIrisConfigBase, IFleetIrisConfigBase } from "./IFleetIrisConfigBase"
import { IGliderFleetCoverageConfig } from "./IGliderFleetCoverageConfig"


export interface IFleetIrisConfigCoverage extends IFleetIrisConfigBase {	
	glider_association:Record<string,[string|null,number|null]>,
	smartplanning_template:{processing_company:string,processing_name:string,processing_iteration:number},
	common_recovery:boolean,
	recovery_point:number,
	resolution_time:number,
	gliders_config:Record<string,IGliderFleetCoverageConfig>
}

export function getDefaultFleetIrisConfigCoverage({
		glider_association={},
		fleet_type=FleetMode.PATHCOVERAGE,
		glider_number=1,
		fleet_company='',
		fleet_name='',
		fleet_state=null,
		fleet_state_timestamp=null,
		smartplanning_template={processing_company:'',processing_name:'',processing_iteration:0},
		common_recovery=false,
		recovery_point=0,
		resolution_time=40,
		gliders_config = {}
	}={}):IFleetIrisConfigCoverage {
	return {
		...getDefaultFleetIrisConfigBase({fleet_type,glider_number,fleet_company,fleet_name,fleet_state,fleet_state_timestamp}),
		glider_association,
		smartplanning_template,
		common_recovery,
		recovery_point,
		resolution_time,
		gliders_config
	} 
}


//retourne une liste de code d'erreur si la configuration n'est pas valide
//si valide pour la simulation le tableau est vide
export function isReadyForIrisFleetCoverage(data:IFleetIrisConfigCoverage|null): Array<string> {
	const errorCode = []	as Array<string>

	if( !data?.smartplanning_template?.processing_company?.length
		|| !data?.smartplanning_template?.processing_name?.length
		|| !data?.smartplanning_template?.processing_iteration
	) errorCode.push("MissingSmartTemplate")	
	if( data?.common_recovery && !data?.recovery_point ) errorCode.push("MissingRecoveryPoint")
	if( !data?.resolution_time || data?.resolution_time < 1 || data?.resolution_time > 120) errorCode.push("MissingResolutionTime")
	if(!data?.glider_association || Object.keys(data.glider_association).some(k => data?.glider_association[k]?.at(0) == null || data?.glider_association[k]?.at(1) == null)) errorCode.push("MissingGliderAssociation")
	
	return errorCode	
}